{
  "_hinweis": "Produktlinien von Happy Energy (ANFORDERUNGEN.md F4). In Stufe 1 nur Sun; Heating und Cooling sind vorbereitet (PLAN.md, Abschnitt 4; O25).",
  "produktlinien": [
    { "schluessel": "sun", "name": "Happy Energy Sun", "aktiv": true },
    { "schluessel": "heating", "name": "Happy Energy Heating", "aktiv": false },
    { "schluessel": "cooling", "name": "Happy Energy Cooling", "aktiv": false }
  ]
}
